/* =========================================
   CONFIG - AUTO-UPDATED WITH YOUR LINKS
   ========================================= */
const BRAND_NAME = "Pehnara";
const WHATSAPP_NUMBER = "+917042399085";

// 1. Your Google Form Submission URL (I fixed the end to /formResponse for you)
const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSerWa58YNjxn3aFj7tCLsCy8uY17gnXASsx8XfTNrYgvVEkiQ/formResponse";

// 2. Your Specific Entry IDs (Extracted from your link)
const GOOGLE_FORM_IDS = {
  name: "entry.1471407171",       // Full Name
  email: "entry.664901198",       // Email
  phone: "entry.606825547",       // Phone
  order_type: "entry.53558302",   // Order Type
  fabric: "entry.1506234465",     // Fabric
  style: "entry.171124776",       // Style Reference
  members: "entry.656357533",     // Member Measurements (Paragraph)
  notes: "entry.673688301"        // Notes
};

/* =========================================
   MAIN CODE (NO EDITS NEEDED BELOW)
   ========================================= */
(function(){
  const root = document.getElementById('pehnara-order-form-root');
  if(!root){ console.warn('pehnara-order-form-root not found'); return; }

  // Inject HTML Structure
  root.innerHTML = `
  <style>
    :root { 
      --gold: #D4AF37; 
      --dark: #1a1a1a; 
      --bg-panel: #FAFAFA;
      --font-serif: "Garamond", "Times New Roman", serif;
      --font-sans: "Helvetica Neue", sans-serif;
    }

    .pehnara-wrap { max-width: 1100px; margin: 40px auto; font-family: var(--font-sans); color: var(--dark); }
    .p-grid { display: grid; grid-template-columns: 1fr 350px; gap: 30px; }
    @media(max-width: 980px) { .p-grid { grid-template-columns: 1fr; } }

    .card { background: #fff; padding: 30px; border: 1px solid #e0e0e0; position: relative; box-shadow: 0 5px 20px rgba(0,0,0,0.02); }
    .card::before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 3px; background: var(--gold); }

    h3 { font-family: var(--font-serif); font-size: 1.8rem; margin: 0 0 20px 0; color: var(--dark); border-bottom: 1px solid #eee; padding-bottom: 10px; }
    .muted { color: #666; font-size: 0.9rem; line-height: 1.5; }

    /* Floating Labels */
    .input-group { position: relative; margin-bottom: 20px; }
    .royal-input, .royal-select, .royal-textarea { width: 100%; padding: 12px 0; border: none; border-bottom: 1px solid #ccc; background: transparent; font-size: 1rem; outline: none; transition: 0.3s; font-family: inherit; border-radius: 0; }
    .royal-input:focus, .royal-select:focus, .royal-textarea:focus { border-bottom-color: var(--gold); }
    
    .floating-label { position: absolute; top: 12px; left: 0; color: #999; pointer-events: none; transition: 0.3s ease all; font-size: 1rem; }
    .royal-input:focus ~ .floating-label, .royal-input:not(:placeholder-shown) ~ .floating-label,
    .royal-select:focus ~ .floating-label, .royal-select:not([value=""]):valid ~ .floating-label,
    .royal-textarea:focus ~ .floating-label, .royal-textarea:not(:placeholder-shown) ~ .floating-label {
      top: -10px; font-size: 0.75rem; color: var(--gold);
    }

    /* Chips */
    .chips { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 5px; margin-bottom: 20px; }
    .chip { padding: 8px 16px; border: 1px solid #ddd; background: #fff; color: #555; cursor: pointer; font-size: 0.85rem; transition: 0.2s; text-transform: uppercase; letter-spacing: 0.5px; }
    .chip:hover { border-color: var(--gold); color: var(--gold); }

    /* Buttons */
    .btn { background: var(--dark); color: #fff; padding: 15px 25px; border: 1px solid var(--dark); cursor: pointer; text-transform: uppercase; letter-spacing: 1px; font-size: 0.9rem; transition: 0.3s; width: 100%; font-weight: 600; }
    .btn:hover { background: var(--gold); border-color: var(--gold); }
    .btn.ghost { background: transparent; color: var(--dark); border: 1px solid #ccc; }
    .btn.ghost:hover { border-color: var(--dark); }
    .wa-btn { background: #25D366; color: #fff; border: none; padding: 12px; width: 100%; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; font-weight: bold; }
    .download-btn { background: #f8f8f8; border: 1px solid #ddd; padding: 8px 12px; font-size: 0.8rem; cursor: pointer; flex: 1; }

    /* Members */
    .member-box { background: var(--bg-panel); padding: 15px; border-left: 3px solid var(--gold); margin-bottom: 15px; }
    .size-panel { display: none; background: #fff; padding: 15px; margin-top: 10px; border: 1px solid #eee; }
    .size-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }

    /* Alerts */
    .error { color: #b02a2a; display: none; margin-top: 15px; font-weight: 600; }
    .success { background: #f0fff4; color: #0b6b35; padding: 15px; border: 1px solid #c3e6cb; margin-top: 15px; display: none; }

    /* Modal */
    #sizeModal { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.6); align-items: center; justify-content: center; z-index: 9999; }
    .modal-content { background: #fff; padding: 30px; max-width: 600px; width: 90%; position: relative; border-top: 4px solid var(--gold); }
  </style>

  <div class="pehnara-wrap">
    
    <div style="text-align:center; margin-bottom:40px;">
      <p class="muted"><h2>Handcrafted to your precise measurements,</h2></p>
    </div>

    <div class="p-grid">
      
      <form id="pehnaraForm" class="card" autocomplete="off">
        <h3>01. Personal Details</h3>
        
        <div class="input-group">
          <input name="name" type="text" class="royal-input" placeholder=" " required>
          <label class="floating-label">Full Name *</label>
        </div>

        <div style="display:grid; grid-template-columns: 1fr 1fr; gap:20px;">
          <div class="input-group">
            <input name="email" type="email" class="royal-input" placeholder=" " required>
            <label class="floating-label">Email Address *</label>
          </div>
          <div class="input-group">
            <input name="phone" type="tel" class="royal-input" placeholder=" " required>
            <label class="floating-label">Phone (WhatsApp) *</label>
          </div>
        </div>

        <div class="input-group">
          <select name="order_type" class="royal-select" required>
            <option value="" disabled selected></option>
            <option value="Individual">Individual Order</option>
            <option value="Mother & Daughter">Mother & Daughter Set</option>
            <option value="Family">Family Set</option>
          </select>
          <label class="floating-label">Order Type *</label>
        </div>

        <br>
        <h3>02. Members & Sizes</h3>
        <p class="muted" style="margin-bottom:15px;">Add each person below.</p>
        
        <div id="membersContainer"></div>

        <div style="display:flex; gap:10px; margin-top:15px;">
          <button type="button" id="addMemberBtn" class="btn ghost">+ Add Another Person</button>
          <button type="button" id="openSizeChartBtn" class="btn ghost" style="width:auto;">Size Guide</button>
        </div>

        <br><br>
        <h3>03. Design Preferences</h3>
        
        <div class="input-group">
          <input id="fabricInput" name="fabric" class="royal-input" placeholder=" ">
          <label class="floating-label">Preferred Fabric / Color</label>
        </div>
        <div class="chips">
          <button type="button" class="chip" data-set="fabric:Velvet · Royal Aubergine">Velvet · Aubergine</button>
          <button type="button" class="chip" data-set="fabric:Silk · Gold">Silk · Gold</button>
        </div>

        <div class="input-group">
          <input id="styleInput" name="style_ref" class="royal-input" placeholder=" ">
          <label class="floating-label">Style Reference</label>
        </div>
        <div class="chips">
          <button type="button" class="chip" data-set="style:Kaftan Set">Kaftan Set</button>
          <button type="button" class="chip" data-set="style:Sharara Suit">Sharara Suit</button>
        </div>

        <div class="input-group">
          <textarea name="notes" class="royal-textarea" rows="2" placeholder=" "></textarea>
          <label class="floating-label">Special Notes</label>
        </div>

        <div style="margin-top:20px; display:flex; align-items:center; gap:10px;">
          <input id="agree" name="consent" type="checkbox" required style="width:auto; cursor:pointer;">
          <label for="agree" style="margin:0; font-weight:normal; font-size:0.9rem;">I agree to be contacted by Pehnara.</label>
        </div>

        <div id="formError" class="error"></div>
        <div id="formSuccess" class="success">
          <strong>Request Sent Successfully!</strong><br>
          We have received your measurements. Please check your WhatsApp/Email shortly.
        </div>
      </form>

      <div class="sidebar">
        <div class="card">
          <h4 style="font-family:var(--font-serif); font-size:1.4rem; margin-top:0;">04. Submit</h4>
          
          <button id="sendBtn" class="btn" type="submit" form="pehnaraForm">Send Request</button>
          
          <hr style="border:0; border-top:1px solid #eee; margin:20px 0;">
          
          <p class="muted" style="margin-bottom:10px;"><strong>Have Reference Photos?</strong><br>Send them directly to our WhatsApp.</p>
          <button id="waShareBtn" class="wa-btn">
             Chat on WhatsApp
          </button>

          <div style="display:flex; gap:10px; margin-top:20px;">
            <button id="downloadJson" type="button" class="download-btn">⬇ JSON</button>
            <button id="downloadPdf" type="button" class="download-btn">📄 PDF</button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div id="sizeModal">
    <div class="modal-content">
      <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
        <h4 style="margin:0;">Measurement Guide</h4>
        <button id="closeSizeModalBtn" style="background:none; border:none; font-size:1.2rem; cursor:pointer;">&times;</button>
      </div>
      <div style="font-size:0.95rem; line-height:1.6; color:#444;">
        <p><strong>1. Chest:</strong> Fullest part of the bust.</p>
        <p><strong>2. Waist:</strong> Narrowest part of the torso.</p>
        <p><strong>3. Hips:</strong> Fullest part of hips.</p>
      </div>
    </div>
  </div>
  `;

  // --- LOGIC SECTION --- //

  const membersContainer = document.getElementById('membersContainer');
  let mid = 0;

  function createMember(rel='', name=''){
    mid++; const id = 'm'+mid;
    const box = document.createElement('div');
    box.className = 'member-box';
    box.innerHTML = `
      <div style="display:flex; justify-content:space-between; align-items:center;">
        <div style="flex:1; display:grid; grid-template-columns:1fr 1fr; gap:10px;">
          <input class="royal-input" name="${id}_rel" placeholder="Relationship" value="${rel}" required>
          <input class="royal-input" name="${id}_name" placeholder="Name" value="${name}" required>
        </div>
        <div style="margin-left:15px;">
           <button type="button" data-action="edit" class="btn ghost" style="padding:8px 15px; font-size:0.8rem;">Edit Sizes</button>
        </div>
      </div>
      
      <div class="size-panel">
        <div style="margin-bottom:15px; display:flex; align-items:center; gap:10px;">
           <span style="font-size:0.85rem; font-weight:bold;">Quick Fill:</span>
           <button type="button" class="chip" data-size="S">S</button>
           <button type="button" class="chip" data-size="M">M</button>
           <button type="button" class="chip" data-size="L">L</button>
        </div>
        <div class="size-grid">
           <div class="input-group"><input class="royal-input" name="${id}_chest" placeholder=" "><label class="floating-label">Chest</label></div>
           <div class="input-group"><input class="royal-input" name="${id}_waist" placeholder=" "><label class="floating-label">Waist</label></div>
           <div class="input-group"><input class="royal-input" name="${id}_hip" placeholder=" "><label class="floating-label">Hips</label></div>
           <div class="input-group"><input class="royal-input" name="${id}_front" placeholder=" "><label class="floating-label">Length</label></div>
        </div>
        <div style="text-align:right; margin-top:10px;"><button type="button" data-action="save" class="btn" style="width:auto; padding:8px 20px;">Save Sizes</button></div>
      </div>
    `;
    membersContainer.appendChild(box);

    const editBtn = box.querySelector('[data-action="edit"]');
    const panel = box.querySelector('.size-panel');
    const saveBtn = box.querySelector('[data-action="save"]');

    editBtn.addEventListener('click', ()=> { 
      const isHidden = panel.style.display !== 'block';
      panel.style.display = isHidden ? 'block' : 'none';
      editBtn.textContent = isHidden ? 'Close' : 'Edit Sizes';
    });

    saveBtn.addEventListener('click', ()=> { panel.style.display = 'none'; editBtn.textContent = 'Edit Sizes'; });
    
    // Quick Fill Logic
    box.querySelectorAll('.chip[data-size]').forEach(s=>{
      s.addEventListener('click', ()=> { 
        const size = s.dataset.size; 
        box.querySelector(`input[name="${id}_chest"]`).value = (size==='S'?34:size==='M'?36:38);
        box.querySelector(`input[name="${id}_waist"]`).value = (size==='S'?28:size==='M'?30:32);
        box.querySelector(`input[name="${id}_hip"]`).value = (size==='S'?36:size==='M'?38:40);
      });
    });
  }

  createMember('Self','');
  document.getElementById('addMemberBtn').addEventListener('click', ()=> createMember('',''));

  // Chips Logic
  document.querySelectorAll('.chips .chip').forEach(c=> c.addEventListener('click', function(){ 
    const kv = this.dataset.set; if(!kv) return; 
    const [k,v] = kv.split(':'); 
    if(k==='fabric') document.getElementById('fabricInput').value = v; 
    if(k==='style') document.getElementById('styleInput').value = v; 
  }));

  // Modals
  document.getElementById('openSizeChartBtn').addEventListener('click', ()=> document.getElementById('sizeModal').style.display='flex');
  document.getElementById('closeSizeModalBtn').addEventListener('click', ()=> document.getElementById('sizeModal').style.display='none');
  
  // WhatsApp
  document.getElementById('waShareBtn').addEventListener('click', ()=> {
    const name = document.querySelector('input[name="name"]').value;
    window.open(`https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g,'')}?text=Hi Pehnara, sharing photos for order by: ${name||'Client'}`, '_blank');
  });

  // Collect Data Helper
  function collectMembers(){ 
    const out = []; 
    document.querySelectorAll('#membersContainer .member-box').forEach(box => {
      const rel = box.querySelector('input[name$="_rel"]').value;
      const name = box.querySelector('input[name$="_name"]').value;
      if(!rel || !name) return;
      let sizes = "";
      const panel = box.querySelector('.size-panel');
      panel.querySelectorAll('input').forEach(i => { if(i.value) sizes += `${i.name.split('_').pop()}: ${i.value}, `; });
      out.push(`${rel} (${name}) - [ ${sizes} ]`);
    });
    return out.join("\n");
  }

  // Download PDF
  document.getElementById('downloadPdf').addEventListener('click', async ()=> {
    if(typeof window.jspdf === 'undefined'){
      await new Promise((res,rej)=>{ 
        const s=document.createElement('script'); 
        s.src='https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'; 
        s.onload=res; s.onerror=rej; 
        document.head.appendChild(s); 
      });
    }
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF(); 
    let y = 20; 
    doc.setFontSize(18); doc.text(`${BRAND_NAME} - Custom Order`, 14, y); y+=10;
    doc.setFontSize(12); doc.text(`Date: ${new Date().toLocaleDateString()}`, 14, y); y+=10;
    
    // Main Details
    const form = document.querySelector('#pehnaraForm');
    doc.text(`Name: ${form.querySelector('input[name="name"]').value}`, 14, y); y+=8;
    doc.text(`Email: ${form.querySelector('input[name="email"]').value}`, 14, y); y+=8;
    doc.text(`Phone: ${form.querySelector('input[name="phone"]').value}`, 14, y); y+=8;
    doc.text(`Type: ${form.querySelector('select[name="order_type"]').value}`, 14, y); y+=8;
    doc.text(`Fabric: ${form.querySelector('input[name="fabric"]').value}`, 14, y); y+=8;
    doc.text(`Notes: ${form.querySelector('textarea[name="notes"]').value}`, 14, y); y+=12;

    doc.setFontSize(14); doc.text("Measurements:", 14, y); y+=8;
    doc.setFontSize(10);
    const members = collectMembers().split('\n');
    members.forEach(m => {
        doc.text(`• ${m}`, 14, y); y+=6;
    });

    doc.save('pehnara-order.pdf');
  });

  // --- SUBMIT TO GOOGLE FORM ---
  document.getElementById('pehnaraForm').addEventListener('submit', function(e){
    e.preventDefault();
    const sendBtn = document.getElementById('sendBtn');
    const err = document.getElementById('formError');
    const success = document.getElementById('formSuccess');
    
    err.style.display = 'none'; success.style.display = 'none';
    sendBtn.disabled = true; sendBtn.textContent = 'Submitting...';

    // 1. Prepare Google Form Data
    const fd = new FormData();
    fd.append(GOOGLE_FORM_IDS.name, this.querySelector('input[name="name"]').value);
    fd.append(GOOGLE_FORM_IDS.email, this.querySelector('input[name="email"]').value);
    fd.append(GOOGLE_FORM_IDS.phone, this.querySelector('input[name="phone"]').value);
    fd.append(GOOGLE_FORM_IDS.order_type, this.querySelector('select[name="order_type"]').value);
    fd.append(GOOGLE_FORM_IDS.fabric, this.querySelector('input[name="fabric"]').value);
    fd.append(GOOGLE_FORM_IDS.style, this.querySelector('input[name="style_ref"]').value);
    fd.append(GOOGLE_FORM_IDS.notes, this.querySelector('textarea[name="notes"]').value);
    
    // Combine all members into one string for the Paragraph field
    fd.append(GOOGLE_FORM_IDS.members, collectMembers());

    // 2. Send via Fetch (no-cors mode)
    fetch(GOOGLE_FORM_URL, {
      method: 'POST',
      mode: 'no-cors',
      body: fd
    }).then(() => {
      success.style.display = 'block';
      this.reset();
      membersContainer.innerHTML = ''; createMember('Self','');
      sendBtn.disabled = false; sendBtn.textContent = 'Send Request';
    }).catch(error => {
      console.error(error);
      err.textContent = "Error submitting form. Please contact us on WhatsApp.";
      err.style.display = 'block';
      sendBtn.disabled = false; sendBtn.textContent = 'Send Request';
    });
  });

})();